import React, { useState, useEffect } from "react";
import { db } from "../firebase-config"; // Firebase Firestore
import { collection, query, where, getDocs } from "firebase/firestore";
import { auth } from "../firebase-config";
import "../css/Homepage.css";

const Homepage = () => {
  const [userEmail, setUserEmail] = useState('');
  const [usertype, setUsertype] = useState('');
  const [lowStockIngredients, setLowStockIngredients] = useState([]);
  const [lowStockProducts, setLowStockProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Set up listener for authentication state changes
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserEmail(user.email);
        const fetchUserType = async () => {
          const usersRef = collection(db, "users");
          const q = query(usersRef, where("email", "==", user.email));
          const querySnapshot = await getDocs(q);

          if (!querySnapshot.empty) {
            const userDoc = querySnapshot.docs[0].data();
            setUsertype(userDoc.usertype); // Set user type in state
          }
        };

        fetchUserType();
      } else {
        setUserEmail('Guest');
        setUsertype('error');
      }
    });

    // Clean up the listener when the component unmounts
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    // Fetch ingredients and products from Firestore

    const fetchLowStockData = async () => {
      try {
        const ingredientSnapshot = await getDocs(collection(db, 'ingredients'));
        const ingredientData = ingredientSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        // Filter and sort ingredients by quantity < 10
        const lowStockIngredients = ingredientData.filter(item => item.quantity < 100);
        lowStockIngredients.sort((a, b) => a.quantity - b.quantity); // Sort by lowest to highest quantity

        // Limit to top 10
        setLowStockIngredients(lowStockIngredients.slice(0, 10));

        const productSnapshot = await getDocs(collection(db, 'products'));
        const productData = productSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        // Filter and sort products by quantity < 5
        const lowStockProducts = productData.filter(item => item.quantity < 100);
        lowStockProducts.sort((a, b) => a.quantity - b.quantity); // Sort by lowest to highest quantity

        // Limit to top 10
        setLowStockProducts(lowStockProducts.slice(0, 10));

        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchLowStockData();
  }, []); // Empty dependency array means this runs only once when the component mounts

  return (
    <div className="homepage">
      <h1 className="homepageText">Welcome to Dimsum Treats Inventory Management System!</h1>
      <h3 className="homepageText">User: {userEmail.split('@')[0]}</h3>
      <h3 className="homepageText">User Type: {usertype}</h3>

      <div className="tables-container">
        {/* Ingredients Table */}
        <div className="table-container">
          <h3>Low Stock Ingredients</h3>
          {loading ? (
            <p>Loading...</p>
          ) : (
            <table className="stock-table">
              <thead>
                <tr>
                  <th>Ingredient</th>
                  <th>Quantity</th>
                </tr>
              </thead>
              <tbody>
                {lowStockIngredients.map((ingredient) => (
                  <tr key={ingredient.id}>
                    <td>{ingredient.name}</td>
                    <td>{parseFloat(ingredient.quantity).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* Products Table */}
        <div className="table-container">
          <h3>Low Stock Products</h3>
          {loading ? (
            <p>Loading...</p>
          ) : (
            <table className="stock-table">
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Quantity</th>
                </tr>
              </thead>
              <tbody>
                {lowStockProducts.map((product) => (
                  <tr key={product.id}>
                    <td>{product.name}</td>
                    <td>{parseFloat(product.quantity).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default Homepage;